import { Component, Host, Prop, State, h } from '@stencil/core';

import { actions as autoCheckActions } from '../../../actions/actions.autocheck';
import { lockQuestion, onVehicleHistoryFormInit } from '../../../actions/actions.validation.vehicleHistory';
import { VehicleHistoryFieldErrors } from '../../../interfaces/interface.validation';
import EventBus from '../../../services/service.eventBus';
import { QUESTION_ARE_QUESTIONS_VERIFIED } from '../../../utils/utils.question';

@Component({
  tag: 'vehicle-history',
  styleUrl: 'vehicle-history.css',
  shadow: true,
})
export class VehicleHistory {
  @Prop() formErrors: Set<string> = new Set();
  @Prop() fieldErrors: VehicleHistoryFieldErrors = {};
  @Prop() hasError: boolean = false;
  @Prop() history = {};
  @Prop() other = {};
  @Prop() questionsHistory = [];
  @Prop() showFormValidation: boolean;
  @Prop() vin: string;
  @Prop() historyFormResult: boolean;
  @Prop() allowAutoAnswer: boolean = false;
  @Prop() theme: string;
  @Prop() alignLeft: boolean = false;

  @State() autocheckFailed: boolean = false;

  async loadAutocheckData() {
    const success = await autoCheckActions.onAutoCheckInit(this.vin);
    this.autocheckFailed = !success;

    if (!success) {
      EventBus.publish('HistoryApiFailure', {});
    }
  }

  private oldMessage: string = "Tell Us About Your Vehicle's History";
  private newMessage: string = "Please Confirm Your Vehicle's History";

  async componentWillLoad() {
    // pass answers and check for answers validation
    onVehicleHistoryFormInit();

    // TODO: this should be moved to something like an actions.history. our history and history validation stores are currently mixing
    // so moving this may take a bit of work to clean up.

    // Only call API if auto answer is true and history questions were either unanswered or were answered manually
    // We can be valid on load if the state was loaded from browser storage
    const hasPreviousAutocheckResult = this.historyFormResult && this.other[QUESTION_ARE_QUESTIONS_VERIFIED].value === 1;
    if (this.allowAutoAnswer && !hasPreviousAutocheckResult) {
      await this.loadAutocheckData();
    }
  }

  componentDidLoad() {
    EventBus.publish('ComponentHasLoaded', 'vehicle-history');
  }

  renderQuestions() {
    return this.questionsHistory.map((q) => {
      const errorMessage = this.fieldErrors[q.questionId] || 'Answer Required';
      const isDirty = this.showFormValidation || q.questionId in this.fieldErrors;

      return (
        <div
          class={{
            'mt-8': true,
            'text-left': this.alignLeft,
          }}>
          <question-proxy
            question={q}
            answers={this.history}
            errorMessage={errorMessage}
            isDirty={isDirty}
            hasError={this.formErrors.has(q.questionId)}
            isLocked={lockQuestion(q)}
          />
        </div>
      );
    });
  }

  render() {
    if (!this.allowAutoAnswer || (this.allowAutoAnswer && this.autocheckFailed)) {
      return (
        <Host data-testId="vehicleHistory">
          <div class={`${this.theme}-theme box-shadow`}>
            <div class="font-ico-body">
              <div class="mb-4">
                <h3 class="ico-components-heading-large mb-3">{this.allowAutoAnswer ? this.newMessage : this.oldMessage}</h3>
                {!this.allowAutoAnswer && <div class="text-sm">Save time and effort at the dealer. Answer each question the best you can.</div>}
              </div>
              {this.renderQuestions()}
            </div>
          </div>
        </Host>
      );
    }
    return;
  }
}
